import { ArrowUpwardRounded } from '@mui/icons-material'
import { Stack, Typography } from '@mui/material'
import { FC } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { LabeledText } from '../../../../../components/CustomTypography'
import { StyledCard } from '../../../../../components/StyledCard'
import { MetricsSelector } from '../../../../../store/TechnologyMetrics'

export const TotalMatchesCard: FC = () => {
  const navigate = useNavigate()

  const totalMatches = useSelector(MetricsSelector.makeTotalMatches)
  const recentMatches = useSelector(MetricsSelector.makeRecentMatchesCount)


  return (
    <StyledCard sx={{ height: '100%', cursor: "pointer" }}>
      <LabeledText
        label="Total matches"
        value={totalMatches}
        valueProps={{ fontSize: '1.5rem' }}
        labelProps={{ fontSize: '1rem', fontWeight: 500 }}
        rootContainerProps={{
          gap: 2,
          direction: 'column',
          alignItems: 'flex-start',
        }}
      />

      <Stack mt={0.5} direction="row" alignItems="center" gap={0.5}>
        {recentMatches && <ArrowUpwardRounded color="primary" />}

        <Typography fontWeight={500} color="primary" fontSize="0.9rem">
          {`${recentMatches} in past 30 days`}
        </Typography>
      </Stack>
    </StyledCard>
  )
}
